module.exports = __webpack_public_path__ + "img/logo.f68f8442.png";